.root {
  display: inline-flex;
}

.fallback {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border-radius: inherit;
}

.clickable {
  cursor: pointer;
}

.name {
  margin-left: 8px;
  margin-top: 8px;
  margin-bottom: 16px;
  cursor: pointer;
  font-size: var(--tuna-typography-caption-fontSize);
}
